import { createTheme } from '@mui/material/styles';
import { BRAND, INPUT_BG, INPUT_HEIGHT, INPUT_BORDER, INPUT_BORDER_HOVER, INPUT_FONT_SIZE, TOKENS } from './tokens';

// --- Dark theme (preserved - uncomment block below and comment light theme to restore) ---
// const theme = createTheme({
//   palette: {
//     mode: 'dark',
//     primary: { main: BRAND.green, contrastText: '#000000', dark: BRAND.greenDark, light: BRAND.greenLight },
//     secondary: { main: TOKENS.colors.violet, contrastText: '#FFFFFF' },
//     background: { default: '#000000', paper: TOKENS.colors.surface },
//     text: { primary: '#F2F2F4', secondary: 'rgba(242, 242, 244, 0.65)', disabled: TOKENS.colors.textMuted },
//     error: { main: '#F87171' },
//     action: { hover: 'rgba(255, 255, 255, 0.06)', selected: 'rgba(255, 255, 255, 0.12)' },
//   },
// });

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BRAND.green,
      contrastText: '#FFFFFF',
      dark: BRAND.greenDark,
      light: BRAND.greenLight,
    },
    secondary: {
      main: TOKENS.colors.violet,
      contrastText: '#FFFFFF',
    },
    background: {
      default: TOKENS.colors.obsidian,
      paper: TOKENS.colors.surface,
    },
    text: {
      primary: TOKENS.colors.textPrimary,
      secondary: TOKENS.colors.textSecondary,
      disabled: TOKENS.colors.textMuted,
    },
    error: { main: '#DC2626' },
    action: {
      hover: 'rgba(15, 23, 42, 0.04)',
      selected: 'rgba(76, 198, 110, 0.12)',
    },
  },
  typography: {
    fontFamily: TOKENS.fonts.body,
    h1: {
      fontFamily: TOKENS.fonts.display,
      fontSize: TOKENS.typography.h1,
      fontWeight: 700,
      lineHeight: 1.05,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: TOKENS.fonts.display,
      fontSize: TOKENS.typography.h2,
      fontWeight: 700,
      lineHeight: 1.08,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: TOKENS.fonts.display,
      fontSize: TOKENS.typography.h3,
      fontWeight: 600,
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
    },
    h4: { fontSize: '1.625rem', fontWeight: 600, lineHeight: 1.25, letterSpacing: '-0.01em' },
    h5: { fontSize: '1.375rem', fontWeight: 600, lineHeight: 1.3 },
    h6: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: TOKENS.typography.body, lineHeight: 1.7 },
    body2: { fontSize: TOKENS.typography.bodySm, lineHeight: 1.65 },
    button: { textTransform: 'none', fontWeight: 600, fontSize: '1rem', letterSpacing: '0.01em' },
    caption: { fontSize: TOKENS.typography.caption, lineHeight: 1.5, color: TOKENS.colors.textMuted },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '.signup-landing-root': {
          backgroundColor: TOKENS.colors.obsidian,
          color: TOKENS.colors.textPrimary,
          scrollbarWidth: 'thin',
          scrollbarColor: `${TOKENS.colors.lime} ${TOKENS.colors.surface}`,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: TOKENS.radius.sm,
          padding: '12px 28px',
          minHeight: '48px',
          fontWeight: 600,
          transition: TOKENS.transition,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: INPUT_BG,
            borderRadius: TOKENS.radius.sm,
            '&:not(.MuiInputBase-multiline)': { height: `${INPUT_HEIGHT}px` },
            '& input': { color: TOKENS.colors.textPrimary, fontSize: INPUT_FONT_SIZE, padding: '0 16px' },
            '& fieldset': { borderColor: INPUT_BORDER },
            '&:hover fieldset': { borderColor: INPUT_BORDER_HOVER },
            '&.Mui-focused fieldset': {
              borderColor: BRAND.green,
              borderWidth: '1px',
              boxShadow: `0 0 0 3px ${TOKENS.glow.accent}`,
            },
            '&.Mui-error fieldset': { borderColor: '#DC2626' },
          },
          '& .MuiFormHelperText-root': { marginLeft: 0, fontSize: TOKENS.typography.caption, color: TOKENS.colors.textMuted },
        },
      },
    },
  },
});

export { BRAND, TOKENS };
export default theme;
